import React, { useEffect, useState } from "react";
import "./Leaderboard.css";

const apiUrl = process.env.REACT_APP_API_URL;

const Leaderboard = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${apiUrl}/leaderboard?type=daily`, { credentials: "include" })
      .then((res) => res.json())
      .then((data) => {
        // datele vin deja ordonate de backend după daily_xp (points)
        setUsers(data);
        setLoading(false);
      })
      .catch((err) => console.error("Eroare leaderboard daily:", err));
  }, []);

  if (loading) return <p>Se încarcă clasamentul de azi...</p>;

  return (
    <div className="leaderboard-wrapper">
      <h2 className="leaderboard-title">Clasament Zilnic</h2>

      {users.length === 0 && (
        <p style={{ marginTop: "20px" }}>Nimeni nu a câștigat XP astăzi.</p>
      )}

      {users.map((user, index) => (
        <div key={user.user_id} className="leaderboard-item">
          <div className="leaderboard-rank">{index + 1}</div>

          <div className="leaderboard-info">
            <p className="leaderboard-name">{user.username}</p>
            <p className="leaderboard-xp">{user.points} XP azi</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Leaderboard;
